import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';

const BooleanField = props => {
  return (
    <FormGroup sx={props.sx || {}} style={props.style || {}}>
      <FormControlLabel
        required={props.required || false}
        label={props.label || null}
        control={
          <Checkbox
            defaultChecked={!!props?.defaultValue}
            onChange={e => props.onChange(e, !!e?.target?.checked)}
            // sx={{
            //   color: 'text.gray',
            // }}
          />
        }
      />
      {props.helperText && <FormHelperText>
          <Typography
            variant='body1'
            color='text.muted'
            pl={4}
          >
            {props.helperText}
          </Typography>
        </FormHelperText>
      }
    </FormGroup>
  );
};

export default BooleanField;